import React from "react";


const Loader = () => {
    return (
        <div id="loader" className="loading_view">
            <div className="loading_center2">
                <div className="loader-table" style={{textAlign: "center"}}>
                    <img style={{background: "transparent"}} src="/assets/images/coploading.gif"/>
                </div>
            </div>
        </div>
    );
}

export default Loader;